import { PhoneInput } from '@/schemas/sceneDataSchema';
import { UseFormReturn } from 'react-hook-form';
import { GenericInput } from './GenericInput';

const formatPhoneNumber = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length <= 3) return digits.length > 0 ? `(${digits}` : '';
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const InputPhoneFormElement = ({ form, component }: { form: UseFormReturn; component: PhoneInput }) => {
  return (
    <GenericInput
      form={form}
      component={component}
      type='tel'
      transformValue={component.auto_format ? (v) => v.replace(/\D/g, '').slice(0, 10) : undefined}
      formatValue={component.auto_format ? formatPhoneNumber : undefined}
    />
  );
};
